import globalConfig from '../config/config';

/**
 * class having all the base urls and redirection urls for different serivecs of zeeve
 */
class BaseUrls {
    /**
     * to get the value from object
     * @param key name of the key to search
     * @returns any
     */
    static getKeyValue = (key: string) => (obj: Record<string, unknown>) => obj[key];

    static getPlatformBackendUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = config.urls.platform.backend;
        }
        return url;
    }

    static getPlatformFrontendUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = config.urls.platform.frontend;
        }
        return url;
    }

    static getProtocolBackendUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = config.urls.protocol.backend;
        }
        return url;
    }

    static getProtocolFrontendUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = config.urls.protocol.frontend;
        }
        return url;
    }

    static getAuthBackendUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = config.urls.other.backend.auth;
        }
        return url;
    }

    static getAuthFrontendUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = config.urls.other.frontend.auth;
        }
        return url;
    }

    static getZeeveManagedValue(): string {
        let value = '';
        const config = globalConfig.getConfig;
        if (config) {
            value = config.zeeveManagedCloud;
        }
        return value;
    }

    static getPlatformDashboardUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.platform.frontend}/dashboard`;
        }
        return url;
    }

    static getPlatformWorkspaceUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.platform.frontend}/workspace`;
        }
        return url;
    }

    static getPlatformBuyAPIEndpointsUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.platform.frontend}/endpoint/buy`;
        }
        return url;
    }

    static getPlatformBuyDedicatedNodesUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.platform.frontend}/marketplace`;
        }
        return url;
    }

    static getPlatformBuyStakingNodesUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.platform.frontend}/marketplace/staking-nodes`;
        }
        return url;
    }

    static getDocsUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = config.urls.other.frontend.docs;
        }
        return url;
    }

    static getVideosUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = config.urls.other.frontend.videos;
        }
        return url;
    }

    static getBuyZDFSUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.other.frontend.zdfs}/purchase-subscription`;
        }
        return url;
    }

    static getZdexerURL(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.zdexerPortalUrl}`;
        }
        return url;
    }

    static getSubgraphUrl(service: 'manage-service' | 'buy-service'): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url =
                service === 'manage-service'
                    ? `${config.subgraphUrl}/dashboard`
                    : `${config.urls.platform.frontend}/indexing-protocol/buy`;
        }

        return url;
    }

    static getPlatformManageAPIEndpointsUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.platform.frontend}/endpoints`;
        }
        return url;
    }

    static getPlatformManageDedicatedNodesUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.platformNew.frontend}/manage/nodes/full`;
        }
        return url;
    }

    static getPlatformManageStakingNodesUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.platformNew.frontend}/manage/nodes/validator`;
        }
        return url;
    }

    static getManageZDFSUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.other.frontend.zdfs}`;
        }
        return url;
    }

    static getPlatformSettingsUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.platform.frontend}/Account`;
        }
        return url;
    }

    static getUserInfo(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.platform.backend}/dashboard/user-info`;
        }
        return url;
    }

    static getHelpDeskUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.other.frontend.helpDesk}`;
        }
        return url;
    }

    static getContactEmail(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.contacts.email}`;
        }
        return url;
    }

    static getInappNotificationsUrl(token: string): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.other.backend.inAppNotificationUrl}?token=${token}`;
            return url;
        }
        return url;
    }

    static getEndpointDetailsUrl(endpointId: string): string {
        let url = '';
        const config = globalConfig.getConfig;

        if (config) {
            const BASE_URL = config.urls.protocol.backend;
            url = `${BASE_URL}/endpoints/${endpointId}`;
        }

        return url;
    }

    static getUpdateEndpointNameOrSecurityUrl(type: string): string {
        let url = '';
        const config = globalConfig.getConfig;

        if (config) {
            const BASE_URL = config.urls.protocol.backend;
            url = `${BASE_URL}/endpoints/update?updateFor=${type}`;
        }

        return url;
    }

    static getEndpointHttpUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;

        url = config?.urls.endpoint.http as string;
        return url;
    }

    static getEndpointWssUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;

        url = config?.urls.endpoint.wss as string;
        return url;
    }

    static getEndpointConsuptionUrl(subscriptionId: string): string {
        let url = '';
        const config = globalConfig.getConfig;

        const BASE_URL = config?.urls.protocol.backend;
        url = `${BASE_URL}/endpoints/subscription/${subscriptionId}`;

        return url;
    }

    static getEndpointMatricsUrl(endpointId: string): string {
        let url = '';
        const config = globalConfig.getConfig;

        const BASE_URL = config?.urls.protocol.backend;
        url = `${BASE_URL}/endpoints/basics/${endpointId}`;

        return url;
    }

    static getEndpointMethodCallUrl(endpointId: string): string {
        let url = '';
        const config = globalConfig.getConfig;

        const BASE_URL = config?.urls.protocol.backend;
        url = `${BASE_URL}/endpoints/method-breakdown/${endpointId}`;

        return url;
    }

    static getEndpointRecentMethodCUrl(endpointId: string): string {
        let url = '';
        const config = globalConfig.getConfig;

        const BASE_URL = config?.urls.protocol.backend;
        url = `${BASE_URL}/endpoints/recent-request/${endpointId}`;

        return url;
    }

    static getOrganizationListUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;

        const BASE_URL = config?.urls.platform.backend;
        url = `${BASE_URL}/organization/list`;

        return url;
    }

    static getItemCode(code: string): string {
        let res = '';

        const config = globalConfig.getConfig;

        if (config) {
            const { itemCode } = config;
            res = itemCode[code];
        }

        return res;
    }

    static getPaymentPlansUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;

        const BASE_URL = config?.urls.protocol.backend;
        url = `${BASE_URL}/payments?usedFor=dedicatedNodes`;

        return url;
    }

    static getSubscriptionUrl(nodeType: string): string {
        let url = '';
        const config = globalConfig.getConfig;

        const BASE_URL = config?.urls.protocol.backend;
        url = `${BASE_URL}/payments?usedFor=${nodeType}`;

        return url;
    }

    static getDeploymentId(): string {
        let id = '';
        const config = globalConfig.getConfig;
        if (config) {
            id = config.deploymentId;
        }
        return id;
    }

    static getWorkspaceListUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.platform.backend}/workspace/list`;
            return url;
        }
        return url;
    }

    static getNetworkListUrl(val: string, type: string): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (!config) return url;
        url = config.urls.protocol.backend;

        if (val === 'all') return `${url}/networks/defaults?nodeType=${type}`;
        else return `${url}/networks/defaults?network=${val}&nodeType=${type}`;
    }

    static getCreateNetworkUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.protocol.backend}/networks`;
            return url;
        }
        return url;
    }

    static getNetworkDetails(id: string | number): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.protocol.backend}/networks/${id}`;
            return url;
        }
        return url;
    }

    static deleteNetworkById(networkId: string | number): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.protocol.backend}/networks/${networkId}/delete`;
            return url;
        }
        return url;
    }

    static deleteEndpointUrl(endpointId: string): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.protocol.backend}/endpoints/${endpointId}/delete`;
            return url;
        }
        return '';
    }

    static getAllNodes(id: string | number): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.protocol.backend}/networks/${id}/nodes`;
            return url;
        }
        return url;
    }

    static addNode(id: string | number): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.protocol.backend}/networks/${id}/nodes`;
            return url;
        }
        return url;
    }

    static getNodeInfoUrl(id: string | number, nodeId: string): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.protocol.backend}/networks/${id}/nodes/${nodeId}/status`;
            return url;
        }
        return url;
    }

    static deleteNodeById(id: string | number, nodeId: string): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.protocol.backend}/networks/${id}/nodes/${nodeId}/delete`;
            return url;
        }
        return url;
    }

    static getRpcDetails(id: string | number, nodeId: string): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.protocol.backend}/networks/${id}/nodes/${nodeId}`;
            return url;
        }
        return url;
    }

    static getAvailableCount(params?: string[]): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            const arrStr = encodeURIComponent(JSON.stringify(params));
            const id = config.protocolId;
            url = `${config.urls.platform.backend}/configuration/node?id=${id}&filter=${arrStr}`;
            return url;
        }
        return url;
    }

    static getCloudRegion(couldId: string | number): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.platform.backend}/cloud/regions/${couldId}`;
            return url;
        }
        return url;
    }

    static getCloudListUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.platform.backend}/cloud/list`;
            return url;
        }
        return url;
    }

    static getCloudCredUrl(cloudId: string): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.platform.backend}/cloud/authorized?cloudId=${cloudId}`;
            return url;
        }
        return url;
    }

    static getInstanceTypesUrl(cloudId: string): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = `${config.urls.protocol.backend}/cloud/instance-types/${cloudId}`;
            return url;
        }
        return url;
    }

    static getPolygoncdkUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = config.polygoncdkUrl;
        }
        return url;
    }

    static getSidebarModuleUrl(): string {
        let url = '';
        const config = globalConfig.getConfig;
        if (config) {
            url = config.module.sidebar;
        }
        return url;
    }
}

export default BaseUrls;
